import React from 'react';

function QuoteMacro(props: {author: string, quote: string}): React.JSX.Element {
	const {
		author,
		quote,
	} = props;

	return (
		<div className="flex gap-md py-xs">
			<div>
				<svg xmlns="http://www.w3.org/2000/svg" width="27" height="20" viewBox="0 0 27 20" fill="none">
					<path d="M0 7.96875C0 4.08398 3.14648 0.9375 7.03125 0.9375H7.5C8.53711 0.9375 9.375 1.77539 9.375 2.8125C9.375 3.84961 8.53711 4.6875 7.5 4.6875H7.03125C5.2207 4.6875 3.75 6.1582 3.75 7.96875V8.4375H7.5C9.56836 8.4375 11.25 10.1191 11.25 12.1875V15.9375C11.25 18.0059 9.56836 19.6875 7.5 19.6875H3.75C1.68164 19.6875 0 18.0059 0 15.9375V14.0625V12.1875V7.96875ZM15 7.96875C15 4.08398 18.1465 0.9375 22.0312 0.9375H22.5C23.5371 0.9375 24.375 1.77539 24.375 2.8125C24.375 3.84961 23.5371 4.6875 22.5 4.6875H22.0312C20.2207 4.6875 18.75 6.1582 18.75 7.96875V8.4375H22.5C24.5684 8.4375 26.25 10.1191 26.25 12.1875V15.9375C26.25 18.0059 24.5684 19.6875 22.5 19.6875H18.75C16.6816 19.6875 15 18.0059 15 15.9375V14.0625V12.1875V7.96875Z" fill="var(--design-color-text-action-secondary-default)"/>
				</svg>
			</div>
			<div className="flex flex-col gap-xxs">
				<p className="!mb-0 text-action-secondary text-balance">{quote}</p>
				<p className="!mb-0 text-[var(--color-greys-800)]">{author}</p>
			</div>
		</div>
	);
}

export default function (props: {author: string, quote: string}): React.JSX.Element {
	return <QuoteMacro {...props} />;
}
